import React, { useEffect, useState } from 'react';
import { Grid, CssBaseline, Typography } from '@material-ui/core';
import { PersonProfileNavbar } from '../../components/personProfileNavbar/personProfileNavbar';
import { useRolesAndCertsStyles } from './style';
import { getRolesReq } from '../../api/person/roleApi';
import { useTranslation } from 'react-i18next';
import { toPropperCase } from '../../utils/stringUtils';
import MaterialTable from 'material-table';
import moment from 'moment';
import { CertificationModel } from '../../models/certificationModel';
import { getCertificationsReq } from '../../api/person/certificationApi';
import { CertificateFamilies } from '../../models/eums/certification/certificateFamilies';
import { RolesModel } from '../../models/rolesModel';
import { localization } from '../../config/localization';

export function RolesAndCerts() {
  const style = useRolesAndCertsStyles();
  const { t } = useTranslation();
  const [personRoles, setPersonRoles] = useState<RolesModel[]>();

  useEffect(() => {
    (async function getPersonProfile() {
      const personRolesResp = await getRolesReq();
      if (personRolesResp && personRolesResp.data) setPersonRoles(personRolesResp.data);
    })();
  }, []);

  async function getRegistrations() {
    let dataSet: CertificationModel[] = [];

    const resp = await getCertificationsReq(CertificateFamilies.OFFICIAL);
    if (resp && resp.data) dataSet = resp.data;

    return {
      data: dataSet,
      page: 0,
      totalCount: dataSet.length,
    };
  }

  return (
    <Grid container>
      <CssBaseline />
      <PersonProfileNavbar selectedIndex={2} />
      <Grid container item>
        <Grid item container>
          <Grid item xs={12} className={style.titleBox}>
            <Typography variant='h5' className={style.titleText}>
              {t('roles')}
            </Typography>
          </Grid>
          <Grid item xs={12} className={style.text}>
            {personRoles?.map((role, index) => (
              <Typography key={'role' + index}>{toPropperCase(role.roleType)}</Typography>
            ))}
          </Grid>
        </Grid>

        <Grid item container>
          <Grid item xs={12} className={style.titleBox}>
            <Typography variant='h5' className={style.titleText}>
              {t('certifications')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <MaterialTable
              options={{
                pageSize: 10,
                showTitle: false,
                toolbar: false,
                headerStyle: {
                  fontWeight: 'bold',
                  backgroundColor: '#F5F5F5',
                },
              }}
              localization={localization()}
              columns={[
                {
                  title: t('type'),
                  field: 'type',
                  render: val => t(val.type || ''),
                },
                {
                  title: t('issued-date'),
                  field: 'certValidity.from',
                  render: val =>
                    val.certValidity?.from && moment(val.certValidity.from).format('DD.MM.YYYY'),
                },
                {
                  title: t('expiry-date'),
                  field: 'certValidity.to',
                  render: val =>
                    val.certValidity?.to && moment(val.certValidity.to).format('DD.MM.YYYY'),
                },
              ]}
              data={getRegistrations}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
